import { VFC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../../components/Button/Button';
import { MeterDetailFooter as messages } from '../messages';

export const MeterDetailFooter: VFC = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <>
      <div className="w-100" style={{ marginRight: 15 }}>
        <Button
          block
          onClick={() => {
            navigate('/meters-list');
          }}
        >
          <FormattedMessage {...messages.back} />
        </Button>
      </div>
      <Button
        block
        style={{ whiteSpace: 'pre-wrap' }}
        type="primary"
        onClick={() => navigate(`/inventorize/${id ?? ''}`)}
      >
        <FormattedMessage {...messages.updateData} />
      </Button>
    </>
  );
};
